import React from "react";
import { Row, Col } from "antd";
import MetricCard from "./Card";
import { useTranslation } from "react-i18next";

export default function MetricCards() {
  const { t } = useTranslation();

  const metrics = [
    {
      title: t("pages.dashboard.metrics.totalRegistrations"),
      value: "8,456",
      trend: "+10%",
      trendPositive: true,
      description: t("pages.dashboard.metrics.overPreviousMonth"),
    },
    {
      title: t("pages.dashboard.metrics.totalSubscribers"),
      value: "78,345",
      trend: "-10%",
      trendPositive: false,
      description: t("pages.dashboard.metrics.overPreviousMonth"),
    },
    {
      title: t("pages.dashboard.metrics.totalRevenue"),
      value: "$2,496,970",
      trend: "-10%",
      trendPositive: false,
      description: t("pages.dashboard.metrics.overPreviousMonth"),
    },
    {
      title: t("pages.dashboard.metrics.pendingInvoices"),
      value: "4",
      link: {
        label: t("pages.dashboard.metrics.viewPendingInvoices"),
        to: "/invoices",
      },
    },
  ];

  return (
    <Row gutter={16}>
      {metrics.map((metric, index) => (
        <Col span={6} key={index}>
          <MetricCard {...metric} />
        </Col>
      ))}
    </Row>
  );
}
